/**
 * Storage Manager pour RapteckMobile React
 * Gère le stockage du token et des données
 */

const KEYS = {
  TOKEN: 'rapteck_token',
  TOKEN_EXPIRY: 'rapteck_token_expiry',
  USER: 'rapteck_user',
  MISSIONS: 'rapteck_missions',
  LAST_SYNC: 'rapteck_last_sync'
};

class StorageManager {
  
  /**
   * Sauvegarde le token et sa date d'expiration
   */
  saveToken(token) {
    try {
      localStorage.setItem(KEYS.TOKEN, token);
      
      // Token valide 90 jours
      const expiryDate = new Date();
      expiryDate.setDate(expiryDate.getDate() + 90);
      localStorage.setItem(KEYS.TOKEN_EXPIRY, expiryDate.toISOString());
      
      console.log('✅ Token sauvegardé (expire le:', expiryDate.toLocaleDateString(), ')');
      return true;
    } catch (error) {
      console.error('❌ Erreur sauvegarde token:', error);
      return false;
    }
  }

  /**
   * Récupère le token
   */
  getToken() {
    try {
      const token = localStorage.getItem(KEYS.TOKEN);
      
      if (!token) {
        return null;
      }

      // Vérifie l'expiration
      const expiry = localStorage.getItem(KEYS.TOKEN_EXPIRY);
      if (expiry && new Date(expiry) < new Date()) {
        console.warn('⚠️ Token expiré');
        this.clearToken();
        return null;
      }

      return token;
    } catch (error) {
      console.error('❌ Erreur récupération token:', error);
      return null;
    }
  }

  /**
   * Récupère la date d'expiration du token
   */
  getTokenExpiry() {
    try {
      const expiry = localStorage.getItem(KEYS.TOKEN_EXPIRY);
      return expiry ? new Date(expiry) : null;
    } catch (error) {
      console.error('❌ Erreur récupération expiration:', error);
      return null;
    }
  }

  /**
   * Vérifie si le token va expirer bientôt (< 7 jours)
   */
  isTokenExpiringSoon() {
    const expiry = this.getTokenExpiry();
    if (!expiry) return false;

    const daysUntilExpiry = Math.floor((expiry - new Date()) / (1000 * 60 * 60 * 24));
    return daysUntilExpiry < 7;
  }

  /**
   * Supprime le token
   */
  clearToken() {
    try {
      localStorage.removeItem(KEYS.TOKEN);
      localStorage.removeItem(KEYS.TOKEN_EXPIRY);
      console.log('🗑️ Token supprimé');
      return true;
    } catch (error) {
      console.error('❌ Erreur suppression token:', error);
      return false;
    }
  }

  /**
   * Sauvegarde les infos utilisateur
   */
  saveUser(user) {
    try {
      localStorage.setItem(KEYS.USER, JSON.stringify(user));
      return true;
    } catch (error) {
      console.error('❌ Erreur sauvegarde user:', error);
      return false;
    }
  }

  /**
   * Récupère les infos utilisateur
   */
  getUser() {
    try {
      const data = localStorage.getItem(KEYS.USER);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error('❌ Erreur récupération user:', error);
      return null;
    }
  }

  /**
   * Supprime les infos utilisateur
   */
  clearUser() {
    try {
      localStorage.removeItem(KEYS.USER);
      return true;
    } catch (error) {
      console.error('❌ Erreur suppression user:', error);
      return false;
    }
  }

  /**
   * Sauvegarde les missions
   */
  saveMissions(missions) {
    try {
      localStorage.setItem(KEYS.MISSIONS, JSON.stringify(missions));
      return true;
    } catch (error) {
      console.error('❌ Erreur sauvegarde missions:', error);
      return false;
    }
  }

  /**
   * Récupère les missions
   */
  getMissions() {
    try {
      const data = localStorage.getItem(KEYS.MISSIONS);
      return data ? JSON.parse(data) : [];
    } catch (error) {
      console.error('❌ Erreur récupération missions:', error);
      return [];
    }
  }

  /**
   * Enregistre la date de dernière sync
   */
  setLastSync(date = new Date().toISOString()) {
    try {
      localStorage.setItem(KEYS.LAST_SYNC, date);
      return true;
    } catch (error) {
      console.error('❌ Erreur sauvegarde last sync:', error);
      return false;
    }
  }

  /**
   * Récupère la date de dernière sync
   */
  getLastSync() {
    try {
      return localStorage.getItem(KEYS.LAST_SYNC);
    } catch (error) {
      console.error('❌ Erreur récupération last sync:', error);
      return null;
    }
  }

  /**
   * Nettoie toutes les données
   */
  clearAll() {
    try {
      this.clearToken();
      this.clearUser();
      localStorage.removeItem(KEYS.MISSIONS);
      localStorage.removeItem(KEYS.LAST_SYNC);
      console.log('🗑️ Toutes les données supprimées');
      return true;
    } catch (error) {
      console.error('❌ Erreur nettoyage complet:', error);
      return false;
    }
  }
}

export default new StorageManager();

